var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('justificatif-table',{ref:"justificatif_beneficiaire",attrs:{"tableEntry":_vm.tableParam,"statusTab":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }